import type { IdeaReference } from "@/types/contentCalendar.type";
import type { BriefVisualSource, ResolvedBriefVisual } from "@/types/productionBrief.type";
import type { MediaChoice } from "../../concepts/IdeaMediaDialog";

/**
 * A shot's or slide's picture as the media dialog reads its `current`: the
 * row's identity (so the dialog marks it picked) and what it shows now.
 */
export function briefVisualAsReference(
  source: BriefVisualSource | undefined,
  resolved: ResolvedBriefVisual | undefined,
): IdeaReference | null {
  const from = resolved?.source ?? source;
  if (!from) return null;
  return {
    kind: from.kind,
    // The dialog reads the shape off the file itself; a row stores none.
    type: "9:16",
    mediaType: resolved?.mediaType ?? from.mediaType,
    platform: "",
    label: resolved?.label ?? from.label ?? "",
    videoUrl: resolved?.videoUrl ?? null,
    imageUrl: resolved?.imageUrl ?? null,
    pageUrl: resolved?.pageUrl ?? from.pageUrl ?? null,
    thumbnailUrl: resolved?.thumbnailUrl ?? from.thumbnailUrl ?? null,
    items: resolved?.items,
    trendId: from.trendId,
    trendExampleId: from.trendExampleId,
    referenceId: from.referenceId,
    mediaId: from.mediaId,
    customMediaId: from.customMediaId,
  };
}

/**
 * What the brief shows for a pick until the save answers with URLs of its own:
 * the dialog's picture, so the card fills the moment the dialog closes.
 */
export function resolvedFromChoice(choice: MediaChoice): ResolvedBriefVisual {
  const mediaType = choice.videoUrl ? "video" : "image";
  return {
    source: { ...choice.pick, mediaType, label: choice.label },
    label: choice.label,
    mediaType,
    imageUrl: choice.imageUrl,
    videoUrl: choice.videoUrl,
    thumbnailUrl: choice.thumbnailUrl,
    pageUrl: null,
    items: [],
    unavailable: false,
  };
}
